import Immutable from 'seamless-immutable';
import { AnyAction } from 'redux';

import { DIFF, CLEAR_DIFF } from 'actions/diff';

const INITIAL_STATE = Immutable({
  loading: false,
  data: null,
  error: null,
});

export default (state = INITIAL_STATE, action: AnyAction) => {
  switch (action.type) {
    case `${DIFF}_LOADING`:
      return state.merge({ loading: true, error: null });
    case DIFF:
      return state.merge({ loading: false, data: action.payload, error: null });
    case CLEAR_DIFF:
      return state.merge({
        loading: false,
        data: null,
        error: null,
      });
    case `${DIFF}_ERROR`:
      return state.merge({ loading: false, error: action.payload });
    default:
      return state;
  }
};
